/* src/app/modules/accounting/reports/profitandloss/accounting-profitandloss.component.css */
.ac-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ac-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ac-page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ac-page-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, .12);
  flex-shrink: 0;
}
.ac-page-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.ac-page-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.ac-page-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.ac-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ac-toolbar {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .07);
  border: 1px solid #e5e7eb;
  padding: 20px 20px 12px;
}
.ac-toolbar__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
.ac-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}
.ac-btn-primary {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-btn-export {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-toolbar__actions mat-spinner {
  margin: 0 !important;
  --mat-progress-spinner-active-indicator-color:var(--cf-brand-dark, #4d7a00);
}
.ac-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.ac-loading__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, .12);
}
.ac-loading__icon mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.ac-loading__dots {
  display: flex;
  gap: 8px;
}
.ac-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: .3;
  animation: ac-anim 1.2s ease-in-out infinite;
}
.ac-loading__dots span:nth-child(2) {
  animation-delay: .2s;
}
.ac-loading__dots span:nth-child(3) {
  animation-delay: .4s;
}
.ac-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes ac-anim {
  0%, 80%, 100% {
    opacity: .3;
    transform: scale(.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.ac-inline-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
}
.ac-inline-dots span {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: .4;
  animation: ac-anim 1.1s ease-in-out infinite;
}
.ac-inline-dots span:nth-child(2) {
  animation-delay: .18s;
}
.ac-inline-dots span:nth-child(3) {
  animation-delay: .36s;
}
.ac-table-wrap {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .07);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}
.fin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.fin-table td {
  padding: 7px 16px;
  border-bottom: 1px solid #f0f0f0;
  color: #1a1d23;
  vertical-align: middle;
}
.fin-table td:last-child {
  text-align: right;
  font-variant-numeric: tabular-nums;
  min-width: 140px;
  white-space: nowrap;
}
.fin-table tr:hover td {
  background: #fef9ec;
}
.fin-table tr.fin-table__section td {
  background: rgba(227, 253, 100, .06);
  font-weight: 700;
  font-size: 11.5px;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #92400e;
  border-bottom: 2px solid rgba(227, 253, 100, .2);
}
.fin-table tr.fin-table__result td {
  font-weight: 700;
  background: #f3f4f6;
  border-top: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
  font-size: 14px;
}
.fin-table tr.fin-table__key-result td {
  font-weight: 700;
  background: #1e2235;
  color: rgba(255, 255, 255, .92);
  font-size: 14px;
  border-top: 3px solid #e3fd64;
}
.fin-table tr.fin-table__key-result td:last-child {
  color: #e3fd64;
}
.fin-table tr.fin-table__sub td:first-child {
  padding-left: 32px;
  color: #6b7280;
  font-size: 13px;
}
/*# sourceMappingURL=accounting-profitandloss.component.css.map */
